import useBodyScrollLock from '@hooks/useBodyScrollLock';
import { ReactComponent as SvgArrowRight } from '@img/icons/arrow-right.svg';
import { ReactComponent as SvgChevronDown } from '@img/icons/chevron-down.svg';
import * as React from 'react';
import LinkButton from '../Buttons/LinkButton/LinkButton';
import S from './NavigationMobile.styles';
const NavigationMobile = ({ cta, items, themeOption = 'light', visible, }) => {
    const [activeId, setActiveId] = React.useState('');
    useBodyScrollLock(visible);
    return (React.createElement(S.Navigation, { "aria-hidden": !visible, themeOption: themeOption, initial: "hidden", animate: visible ? 'visible' : 'hidden', variants: {
            hidden: {
                opacity: 0,
                transitionEnd: {
                    display: 'none',
                },
            },
            visible: {
                display: 'block',
                opacity: 1,
            },
        }, transition: {
            duration: 0.3,
            ease: 'easeOut',
            type: 'tween',
        } },
        React.createElement(S.NavigationOverflow, null,
            React.createElement(S.NavigationList, null,
                items.map((item) => {
                    const isActive = activeId === item.id;
                    const hasChildren = !!item.children?.length;
                    return (React.createElement(S.NavigationItem, { key: item.id, initial: "closed", animate: isActive ? 'opened' : 'closed' },
                        React.createElement(S.NavigationLink, { href: item.url, tabIndex: visible ? 0 : -1, target: item.target, onClick: (event) => {
                                if (!hasChildren) {
                                    return setActiveId('');
                                }
                                event.preventDefault();
                                if (isActive) {
                                    return setActiveId('');
                                }
                                else {
                                    return setActiveId(item.id);
                                }
                            } },
                            item.text,
                            hasChildren && (React.createElement(S.NavigationIcon, { style: { x: 'calc(100% + 16px)', y: 'calc(-50% + 2px)' }, variants: {
                                    closed: {
                                        rotate: 0,
                                    },
                                    opened: {
                                        rotate: 180,
                                    },
                                } },
                                React.createElement(SvgChevronDown, null)))),
                        !!item.children?.length && (React.createElement(S.ChildList, { variants: {
                                closed: {
                                    height: 0,
                                },
                                opened: {
                                    height: 'auto',
                                },
                            }, transition: {
                                duration: 0.3,
                                ease: 'easeOut',
                                type: 'tween',
                            } },
                            item.url && (React.createElement(S.ChildItem, { key: item.id },
                                React.createElement(S.ChildLink, { href: item.url, tabIndex: visible ? 0 : -1, target: item.target }, "Overview"))),
                            item.children.map((item) => (React.createElement(S.ChildItem, { key: item.id },
                                React.createElement(S.ChildLink, { href: item.url, tabIndex: visible ? 0 : -1, target: item.target }, item.text))))))));
                }),
                cta?.text && (React.createElement(S.CtaWrapper, null,
                    React.createElement(LinkButton, { themeOption: themeOption === 'light' ? 'purple' : 'white', href: cta.url, icon: SvgArrowRight, target: cta.target, title: cta.text })))))));
};
export default NavigationMobile;
